export const showLoader = () => {
	const loader = document.querySelector(".loader-wrapper");
	loader.classList.remove("u-hidden");
};

export const hideLoader = () => {
	const loader = document.querySelector(".loader-wrapper");
	loader.classList.add("u-hidden");
};
